/* global Slider */
(function() {
    'use strict';
    angular.module('emarket.commons').directive('slider', ['$interval', '$log', '$q', '$timeout', function($interval, $log, $q, $timeout) {
        var thumbs;
        return {
            scope: {
                slider: '='
            },
            link: function(scope, element) {
                var slider;

                var slideEndEvent = function() {
                    angular.element(thumbs).removeClass('active');
                    angular.element(thumbs[slider.current]).addClass('active');
                };
                element[0].addEventListener('slideend', slideEndEvent);
                scope.$on('$destroy', function() {
                    element[0].removeEventListener('slideend', slideEndEvent);
                });
                scope.$on('$destroy', function() {
                    $log.info('destroying');
                });
                scope.$watch(function() {
                    return scope.slider;
                },
                function() {
                    // var children = element.children()[0];
                    if (element === undefined) {
                        return;
                    }
                    var images = element.children()[0].querySelectorAll('img');
                    var loadCount = 0;
                    // var loadTotal = images.length;
                    var arrows = element[0].querySelectorAll('.z-slide-arrows button');
                    thumbs = element[0].querySelectorAll('.z-slide-thumbnails img');
                    var moveSliderTo = function(current, selected) {
                        var move;
                        var moveTo;
                        if (current > selected) {
                            move = current - selected;
                            moveTo = 'right';
                        } else {
                            move = selected - current;
                            moveTo = 'left';
                        }
                        if (move > 0) {
                            $interval(function() {
                                slider.slide(moveTo);
                            },
                            10,
                            move);
                        }
                    };
                    angular.element(arrows[0]).on('click', function(e) {
                        e.stopPropagation();
                        slider.slide('right');
                    });
                    angular.element(arrows[1]).on('click', function(e) {
                        e.stopPropagation();
                        slider.slide('left');
                    });

                    thumbs[0].classList.add('active');
                    thumbs.forEach(function(thumb) {
                        angular.element(thumb).on('click', function(e) {
                            e.stopPropagation();
                            var id = this.attributes['data-image-id'].value;
                            moveSliderTo(slider.current, id);
                        });
                    });

                    images.forEach(function(image) {
                        image.opacity = 0;
                        image.onload = function() {
                            loadCount += 1;
                            var img = this;
                            $timeout(function() {
                                img.parentNode.style.height = img.offsetHeight ? img.offsetHeight + 'px' : '100%';

                                // element.css('height', this.offsetHeight + 'px');
                                if (loadCount === images.length) {
                                    slider = new Slider(element[0].querySelector('.pictures__main'),
                                        '.z-slide-item',
                                        {
                                            autoplay: false,
                                            duration: 0.2
                                        });
                                }
                            }, 300);
                        };
                    });
                });
            }
        };
    }]);
}());
